// Transitions Language
import { createI18n } from 'vue-i18n';
import { ar as vuetifyAr, en as vuetifyEn } from 'vuetify/locale';

import ar from '@/locale/ar';
import en from '@/locale/en';

export const messages = {
  en: {
    ...en,
    $vuetify: vuetifyEn,
  },
  ar: {
    ...ar,
    $vuetify: vuetifyAr,
  },
};
// Set default language
const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  globalInjection: true,
  silentTranslationWarn: true,
  messages,
});
export { i18n };
